// extracted by mini-css-extract-plugin
export var headerCell = "_5a-1";
export var loadingSpinnerContainer = "_5a-4";
export var loadingStateCell = "_5a-5";
export var rowWrapper = "_5a-3";
export var standaloneTable = "_5a-6";
export var table = "_5a-0";
export var white = "_5a-2";